(function () {
  "use strict";

  if (window.__mutKlaviyoBisBootstrapDone) {
    return;
  }
  window.__mutKlaviyoBisBootstrapDone = true;

  var KLAVIYO_SCRIPT_SRC = "https://a.klaviyo.com/media/js/onsite/onsite.js";
  var KLAVIYO_SCRIPT_ATTR = "data-mut-klaviyo-bis-script";

  function getConfigNode() {
    return document.querySelector("[data-mut-klaviyo-bis]");
  }

  function getConfig() {
    var node = getConfigNode();

    if (!node) {
      return null;
    }

    var account = node.getAttribute("data-account") || "";
    var theme = node.getAttribute("data-theme") || "light";
    var includeAdditionalStyles =
      node.getAttribute("data-include-additional-styles") === "true";

    return {
      account: account,
      theme: theme,
      includeAdditionalStyles: includeAdditionalStyles,
    };
  }

  function getBisOptions(config) {
    var isDarkTheme = config.theme === "dark";

    var modal = {
      headline: "{product_name}",
      body_content:
        "Register to receive a notification when this item comes back in stock.",
      email_field_label: "Email",
      button_label: "Notify me when available",
      subscription_success_label: "You're in! We'll let you know when it's back.",
      footer_content: "",
      drop_background_color: "#000",
      background_color: isDarkTheme ? "transparent" : "#fff",
      text_color: isDarkTheme ? "#fff" : "#222",
      button_text_color: "#fff",
      button_background_color: "#439fdb",
      close_button_color: "#ccc",
      error_background_color: "#fcd6d7",
      error_text_color: "#C72E2F",
      success_background_color: "#d3efcd",
      success_text_color: "#1B9500",
    };

    if (config.includeAdditionalStyles) {
      modal.additional_styles =
        "* { font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; }";
    }

    return {
      trigger: {
        product_page_text: "Notify Me When Available",
        product_page_class: "btn",
        product_page_text_align: "center",
        product_page_margin: "0px",
        replace_anchor: false,
      },
      modal: modal,
    };
  }

  function initializeBackInStock(config) {
    if (!config || !config.account || window.__mutKlaviyoBisInitialized) {
      return;
    }

    var klaviyo = window.klaviyo;

    if (
      !klaviyo ||
      typeof klaviyo.init !== "function" ||
      typeof klaviyo.enable !== "function"
    ) {
      return;
    }

    window.__mutKlaviyoBisInitialized = true;

    klaviyo.init({
      account: config.account,
      platform: "shopify",
    });

    klaviyo.enable("backinstock", getBisOptions(config));
  }

  function loadKlaviyoAndInit(config) {
    if (!config || !config.account || window.__mutKlaviyoBisInitialized) {
      return;
    }

    var existingScript = document.querySelector("script[" + KLAVIYO_SCRIPT_ATTR + "]");

    if (existingScript) {
      if (existingScript.getAttribute("data-loaded") === "true") {
        initializeBackInStock(config);
      } else {
        existingScript.addEventListener(
          "load",
          function () {
            initializeBackInStock(config);
          },
          { once: true }
        );
      }
      return;
    }

    var script = document.createElement("script");
    script.src = KLAVIYO_SCRIPT_SRC;
    script.async = true;
    script.setAttribute(KLAVIYO_SCRIPT_ATTR, "true");
    script.addEventListener(
      "load",
      function () {
        script.setAttribute("data-loaded", "true");
        initializeBackInStock(config);
      },
      { once: true }
    );

    document.head.appendChild(script);
  }

  function scheduleInitialization() {
    var config = getConfig();

    if (!config || !config.account) {
      return;
    }

    loadKlaviyoAndInit(config);
  }

  function startWhenReady() {
    if (document.readyState === "complete") {
      if (typeof window.requestIdleCallback === "function") {
        window.requestIdleCallback(scheduleInitialization, { timeout: 2000 });
      } else {
        window.setTimeout(scheduleInitialization, 0);
      }
      return;
    }

    window.addEventListener(
      "load",
      function () {
        if (typeof window.requestIdleCallback === "function") {
          window.requestIdleCallback(scheduleInitialization, { timeout: 2000 });
        } else {
          window.setTimeout(scheduleInitialization, 0);
        }
      },
      { once: true }
    );
  }

  startWhenReady();
})();
